import { useEffect } from 'react'

interface Props {
  loadMoreFunc: Function
  data: any[]
  stopLoadingData: boolean
}

export default function useWindowInfiniteScroll({
  loadMoreFunc,
  data,
  stopLoadingData
}: Props) {
  useEffect(() => {
    if (stopLoadingData) {
      return
    }

    let isThrottled = false

    function scrollEvent() {
      if (isThrottled) return

      const scrollBottom =
        window.scrollY + window.innerHeight >=
        document.documentElement.scrollHeight - 50

      if (scrollBottom) {
        isThrottled = true
        loadMoreFunc()
        setTimeout(() => {
          isThrottled = false
        }, 400)
      }
    }

    window.addEventListener('scroll', scrollEvent)

    return () => window.removeEventListener('scroll', scrollEvent)
  }, [data, stopLoadingData])
}
